// Collapsible element 

const collapsibleTitle = document.querySelector('.article__collapsible');
if (collapsibleTitle) {
  collapsibleTitle.addEventListener('click', () => {
    document.querySelector('.article__collapsible-content').classList.toggle('article__collapsible-content--is-hidden');
    document.querySelector('.article__atc-ingredients').classList.toggle('article__collapsible-content--is-hidden');
    collapsibleTitle.classList.toggle('article__collapsible--is-not-expanded');
  });
}

// Sticky upsell

document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    // Doc of hcSticky : https://github.com/somewebmedia/hc-sticky

    // The element in the first argument is hcSticky that will be sticky
    // The stickTo option refers to the container of the sticky element

    var Sticky = new hcSticky('.article-sticky-upsell', {
      stickTo: '.article__body',
      top: 130,
      innerTop: 10
    });
  } else if (document.querySelector('.article-sticky-upsell')) {
    // On mobile, hide the sticky div when over footer
    window.addEventListener('scroll', function () {
      let footerOffset = document.querySelector('.site-footer').getBoundingClientRect().top - window.innerHeight;
      if (footerOffset < 0) {
        document.querySelector('.article-sticky-upsell').classList.add('is-hidden');
      } else {
        document.querySelector('.article-sticky-upsell').classList.remove('is-hidden');
      }
    });
  }
});

// Add amoseeds products button (add all article in upsell on click of '.article__atc-ingredients' btn)

const atc = document.querySelector('.article__atc-ingredients');
const productIds = atc.closest('.article').querySelector('.article-sticky-upsell').getAttribute('data-products-id');

// Hide the "Add all" button if no available product is found
if (!productIds) {
  atc.style.display = 'none';
}
if (atc) {
  atc.addEventListener('click', e => {
    e.preventDefault();
    const productIdsArray = productIds.split(',');
    let formData = {
      "items": []
    };
    productIdsArray.forEach(id => {
      formData.items.push({
        "id": id,
        "quantity": 1
      });
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          data: data
        }
      }));

      // Refresh cart
      theme.cart._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({})
      });
    }).catch(error => {
      console.error('Error:', error);
    });
  });
}